import type { MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import {CommandLineIcon, CircleStackIcon, CloudIcon, GlobeAltIcon, WrenchScrewdriverIcon, CpuChipIcon } from '@heroicons/react/24/outline';

export const meta: MetaFunction = ({ data, params }: { data: any, params: any }) => {
  const title = `Browser Extension - Related Repos`;
  const description = 'Browser extension for Chrome, Edge, and Firefox. Quickly view alternative repositories while browsing open source projects online. Find useful libraries.';
  const canonicalURL = `${__BASE_URL__}/extension`;
  const jsonLD = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": canonicalURL
  };

  return [
    { title },
    { name: "description", content: description },
    { tagName: "link", rel: "canonical", href: canonicalURL },
    { "script:ld+json": jsonLD },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonicalURL },
    { property: "og:image", content: __OG_IMAGE__ }
  ];
};

export default function Index() {
  return (
    <>
      <div className="background-gray px-2 py-2 border border-gray-100 rounded-md">
        <div className="flex items-center py-1">
          <h1 className="text-xl font-bold mr-1 ">
            Browser Extension
          </h1>
        </div>
      </div>

      <div className="max-w-prose mx-auto pb-10 ">
        <p className="mt-4 mb-5 text-xl text-center">
          Quickly view related repositories while browsing on GitHub
        </p>

        <div className="flex justify-center gap-x-5 gap-y-4 flex-wrap mb-6 mt-2">
          <a href="https://chromewebstore.google.com/detail/related-repos/hjjchbgenhmnndipngamcilolaahgngc" type="button" className="text-rr-button-blue-primary background-button-blue inline-flex items-center gap-x-1.5 rounded-full px-4 py-2.5 text-sm font-semibold shadow-sm ring-1 ring-inset ring-gray-300">
            {/* TODO: icon dark mode light grey */}
            <img src="/images/logos/chrome.svg" width="16" alt="Chrome logo" />
            Add to Chrome
          </a>
          {/* <Link to="/" type="button" className="inline-flex items-center gap-x-1.5 rounded-full bg-blue-50 px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            <img src="/images/logos/firefox.svg" width="16" alt="Firefox logo" />
            Add to Firefox
          </Link>
          <Link to="/" type="button" className="inline-flex items-center gap-x-1.5 rounded-full bg-blue-50 px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            <img src="/images/logos/edge.svg" width="16" alt="Edge logo" />
            Add to Edge
          </Link> */}
        </div>

        <div className="flex justify-center gap-x-5 gap-y-4 flex-wrap mb-6 mt-2">
          * Firefox and Edge support coming soon
        </div>

        <video className="mx-auto border border-gray-400 rounded" width="600" controls autoPlay loop muted>
          <source src="https://d2jboulw3rwjex.cloudfront.net/videos/2025-05-27_extension_recording.mov" type="video/mp4" />
          {/* fallback to image if video not supported */}
          <img width="600" src="/images/extension_screenshot.png" alt="Browser extension screenshot" />
        </video>

        <ul className="text-lg list-disc pl-8 mt-4">
          <li className="py-1">
            Activate the extension when viewing a public repository on GitHub
          </li>
          <li className="py-1">
            The results will display alternative and complementary projects
          </li>
          <li className="py-1">
            Select the "External links" tab to view useful websites specific to the current repository
          </li>
          <li className="py-1">
            Easily search for any repo by typing "rr" + [Tab] in the address bar
          </li>
          <li className="py-1">
            Alternatively, use the <Link to="/bookmarklet" className="text-rr-link">official bookmarklet</Link> for a lighter experience
          </li>
        </ul>

      </div>
    </>
  );
}
